import { AfterViewInit, Component, Input, OnInit, ViewChild, inject } from '@angular/core';
import { IonSearchbar, IonicModule } from '@ionic/angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { from, take } from 'rxjs';
import { searchValueChange } from 'src/app/data/store/actions/filters.actions';
import { searchLimit } from '../../constants';
import { CurrentPlatform, FiltersOptions, SectionsListModes } from '../../enums';
import { selectCurrentPlatform } from '../../../data/store/selectors/platform.selectors';
import { FormsModule } from '@angular/forms';

import { FiltersButtonComponent } from '../filters-modal/components/filters-button/filters-button.component';
import { getSectionsList } from 'src/app/data/store/actions/training.action';

@UntilDestroy()
@Component({
  selector: 'app-search-bar-with-filters',
  templateUrl: './search-bar-with-filters.component.html',
  styleUrls: ['./search-bar-with-filters.component.scss'],
  imports: [FormsModule, IonicModule, FiltersButtonComponent],
})
export class SearchBarWithFiltersComponent implements OnInit, AfterViewInit {
  private _store = inject(Store);

  @ViewChild('searchbar') searchbar: IonSearchbar | undefined;

  @Input() searchBarText = 'Поиск';

  @Input() isNeedFiltersButton = true;

  @Input() isFavoriteOption = false;

  @Input() isCheckboxType = false;

  @Input() currentMode: string | undefined;

  @Input() excludeSingleFiltersOptions: FiltersOptions[] = [];

  currentPlatform: CurrentPlatform | null | undefined;

  public dataForFilters: {
    withFavoriteOption?: boolean;
    isCheckboxType?: boolean;
  } | null = null;

  ngOnInit(): void {
    this.dataForFilters = {
      withFavoriteOption: this.isFavoriteOption,
      isCheckboxType: this.isCheckboxType,
    };

    this._store
      .select(selectCurrentPlatform)
      .pipe(untilDestroyed(this))
      .subscribe((platform: CurrentPlatform | null) => (this.currentPlatform = platform));
  }

  public ngAfterViewInit() {
    if (this.searchbar) {
      from(this.searchbar.getInputElement())
        .pipe(untilDestroyed(this), take(1))
        .subscribe((input) => {
          input.maxLength = searchLimit;
        });
    }
  }

  public searchValueChange(event: any) {
    this._store.dispatch(searchValueChange({ searchValue: event.detail.value }));
    if (this.currentMode === SectionsListModes.listViewMode) {
      this._store.dispatch(getSectionsList());
    }
  }
}
